import React from 'react';
import PropTypes from 'prop-types';
import Card from 'partial/components/Card';
// import { useHistory } from 'react-router-dom';
import Button from 'partial/components/Button';
import { useMerchantSelected } from 'core-modules/merchants/hooks';
import IconSubmittedSuccess from 'assets/images/icons/icon-submitted-success.svg';
import IconCheckDanger from 'assets/images/icons/icon-invalid-activation.svg';

function ApplicationStatus({ onBack }) {
  // const history = useHistory();
  const [, data] = useMerchantSelected();

  if (data?.approval_status === 'REJECTED') {
    return (
      <Card>
        <div className="space-y-4 max-w-3xl mx-auto p-12">
          <div className="flex flex-col items-center">
            <img
              src={IconCheckDanger}
              alt="icon-check-success"
              className="h-40 w-40"
            />
            <div className="w-full flex flex-col items-center space-y-3 border-b mt-6 mb-4 pb-4 ">
              <h1 className="text-2xl text-center text-danger-600">
                Account Application Submitted
              </h1>
              <div className="w-96">
                <p className="font-semibold text-center text-danger-600">
                  There is an item submitted that did not pass our verification.
                </p>
              </div>
            </div>
            <Button
              outlinePrimary
              size="xl"
              onClick={() => {
                onBack();
              }}
            >
              Resubmit Your Application
            </Button>
          </div>
        </div>
      </Card>
    );
  }

  return (
    <Card>
      <div className="space-y-4 max-w-3xl mx-auto p-12">
        <div className="flex flex-col items-center">
          <img
            src={IconSubmittedSuccess}
            alt="icon-check-success"
            className="h-40 w-40"
          />
          <div className="w-full flex flex-col items-center space-y-3 border-b mt-6 mb-6 pb-4 ">
            <h1 className="text-2xl text-center text-yellow-600">
              Account Application Submitted
            </h1>
            <div className="text-center">
              <p>Thank you for submitting your application!</p>
              <p>
                We will contact you within the next 7 working days regarding
                your application status.
              </p>
              <p>
                Please note that submissions will only be accepted until 3:00pm
                daily.
              </p>
            </div>
          </div>
          {/* <Button primary size="xl" onClick={() => {}}>
            Back to Dashboard
          </Button> */}
        </div>
      </div>
    </Card>
  );
}

ApplicationStatus.propTypes = {
  onBack: PropTypes.func.isRequired,
};

export default ApplicationStatus;
